/** Мінімальна довжина запиту глобального пошуку (після нормалізації). */
export const SEARCH_MIN_LENGTH = 2

/** Лише цифри й знаки запису телефону: `+ ( ) - .` і пробіли. */
const PHONE_LIKE = /^[\d+()\-.\s]+$/

/**
 * Запит до `/services/search` (`SPEC-014` §5.3, Ґ16).
 *
 * Телефони в базі нормалізовані до цифр (`SPEC-002` §2.7), а пошук ядра —
 * підрядок, тож «+38 (067) 123-45-67» як є нічого б не знайшов. Запит, у якому
 * немає нічого, крім цифр і знаків запису телефону, зводимо до цифр:
 * «+38 (067) 123-45-67» → «380671234567», «067 123» → «067123». Решту
 * (назва, пошта, ЄДРПОУ з літерами поруч) лишаємо як є, лише без крайніх
 * пробілів.
 */
export const normalizeSearchQuery = (raw: string): string => {
    const value = raw.trim()

    if (PHONE_LIKE.test(value) && /\d/.test(value)) {
        return value.replace(/\D/g, '')
    }

    return value
}

/** Чи досить запиту, щоб іти на сервер. */
export const isSearchable = (query: string): boolean => query.length >= SEARCH_MIN_LENGTH
